import { render, staticRenderFns } from "./SplitOverview.template.vue?vue&type=template&id=7f59aa62&scoped=true&"
var script = {}
import style0 from "./SplitOverview.template.vue?vue&type=style&index=0&id=7f59aa62&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f59aa62",
  null
  
)

export default component.exports